uniform vec3 uBaseColor;
uniform float uSize;
uniform float uTime;
uniform float uStep;
uniform float uStepRange;
uniform float uBaseColorPower;
uniform float uDirection;
uniform float uOpacity;
varying float vCarrierDistance;

varying vec2 vUv;

void main() {
  float opacity = pow(sin((vUv.y + uTime * uDirection) * (1. / uSize)), 2.);
  opacity = smoothstep(uStep - uStepRange, uStep + uStepRange, opacity);
  opacity += 0.1;

  float dist = max(1. - vCarrierDistance * .5, 0.);
  // dist = pow(dist, 2.5);

  opacity *= dist;
  gl_FragColor = vec4(uBaseColor * uBaseColorPower, opacity * uOpacity);
}